import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import { modifiedText } from '../../helpers/symbols';
import Sparkline from '../../components/Sparklines';
import ExpandUrls from './modal/ExpandUrls';

export const COLUMNS = (default_image) => [
    {
        label: 'Page',
        key: 'page',
        data: 'page',
        cellSize: 'minmax(400px, 5fr)',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            let title = item.title;
            const url = item.impressions_by_slug?.[0]?.unique_url_slug;
            if (!item.title) {
                title = url;
            }
            title = modifiedText(title);
            if (csvDownload) return title;

            return (
                <div>
                    <div className="d-flex align-items-center">
                        <div style={{ display: 'contents' }}>
                            <img
                                onError={(event) => (event.target.src = default_image)}
                                src={item.image ?? default_image}
                                style={{
                                    background: '#BBB',
                                    width: '70px',
                                    borderRadius: '8px',
                                    objectFit: 'cover',
                                }}
                                alt="page_image"
                                loading="lazy"
                            />
                        </div>
                        <div style={{ marginLeft: '8px' }}>
                            <strong>
                                <span className="text-wrap" title={title}>
                                    {title}
                                </span>
                                <a
                                    target="_blank"
                                    className="link-website d-inline-flex align-items-center justify-content-center"
                                    href={item.url}
                                    rel="noreferrer"
                                >
                                    <i className="icon-external-link"></i>
                                </a>
                            </strong>
                        </div>
                    </div>
                </div>
            );
        },
    },
    {
        label: 'Article ID',
        key: 'PageId',
        data: 'PageId',
        Component: Cell,
    },
    {
        label: 'Unique URLs',
        key: 'UniqueURLs',
        data: 'UniqueURLs',
        Component: Cell,
    },
    {
        label: 'Unique Titles',
        key: 'uniqueTitles',
        data: 'uniqueTitles',
        Component: Cell,
    },
    {
        label: 'Lifespan',
        key: 'age',
        data: 'age',
        Component: Cell,
    },
    {
        label: 'Impressions',
        key: 'total_impressions',
        data: 'total_impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <div>{numeral(data).format('0.0a')}</div>;
        },
    },
    {
        label: 'Trend',
        key: 'trend',
        data: 'trend',
        Component: Cell,
        cellSize: 'minmax(200px, 2fr)',
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return null;

            const sortedData = item.impressions_by_day?.sort(
                (a, b) => new Date(a.date.value) - new Date(b.date.value),
            );

            const labels = sortedData?.map((x) => x.date?.value);
            const values = sortedData?.map((x) => x.daily_total_impressions);
            const titleType = (date) => `DATE: ${date}`;
            return (
                <Sparkline
                    dataL={values}
                    keyName="Impressions"
                    labels={labels}
                    titleType={titleType}
                />
            );
        },
    },
    {
        label: 'Clicks',
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <div>{numeral(data).format('0.0a')}</div>;
        },
    },
    {
        label: 'CTR',
        key: 'ctr',
        data: 'ctr',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            const ctrValue = item.clicks / item.total_impressions;
            if (csvDownload) return ctrValue;

            return <div>{numeral(ctrValue).format('0.00%')} </div>;
        },
    },
    {
        label: 'Expand URLs',
        key: 'expand_urls',
        data: 'expand_urls',
        Component: Cell,
        renderCell: ({ item, csvDownload }) =>
            !csvDownload ? <ExpandUrls items={item.impressions_by_slug} /> : null,
    },
];
